var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col items-center"
  }, [_c('create-new-folder', {
    attrs: {
      "data-to-show": _vm.isCreateFolderPopupDisplayed,
      "errors": _vm.errorsCreateNewFolder
    },
    on: {
      "showChange": function (val) {
        _vm.displayPopupAddNewFolder(val);
      },
      "createNewFolder": function (folder) {
        _vm.createFolder(folder);
      }
    }
  }), _vm._v(" "), _c('add-new-file', {
    attrs: {
      "data-to-show": _vm.stateAddFilePopup,
      "loading": _vm.addNewFileLoading,
      "file-temp": _vm.fileTemp,
      "errors": _vm.errorsAddNewFile
    },
    on: {
      "showChange": function (val) {
        _vm.changeStatePopupAddNewFile(val);
      },
      "addTempFile": function (data) {
        _vm.addTempFile(data);
      },
      "addFile": function (infos) {
        _vm.addFile(infos);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 flex flex-col space-y-2 text-center mb-10"
  }, [_c('p', [_vm._v("\n      Votre dépôt de documents est vierge,\n    ")]), _vm._v(" "), _vm.canEdit ? _c('p', [_vm._v("\n      commencez par déposer votre premier fichier ou créer un dossier.\n    ")]) : _vm._e()]), _vm._v(" "), _vm.canEdit ? _c('div', {
    staticClass: "flex space-x-6 mb-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "DÉPOSER UN FICHIER",
      "uppercase": true,
      "icon": "file-add",
      "responsive": true,
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeStatePopupAddNewFile(1);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-indigo-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-white",
      "bg-color-square": "bg-white",
      "icon-color": "text-pink-600",
      "libelle": "CRÉER UN DOSSIER",
      "uppercase": true,
      "icon": "folder-add",
      "responsive": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.displayPopupAddNewFolder(true);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }